/* eslint-disable max-len */

import BulkTransactionsService from '../../services/BulkTransactionsService';
import ErrorHandlerHelpers from '../../mixins/ErrorHandlerHelpers';
import Idb from '../../services/IndexedDbService';

const SET_BULK_TRANSACTION_TYPES = 'SET_BULK_TRANSACTION_TYPES';
const CLEAR_BULK_TRANSACTION_TYPES = 'CLEAR_BULK_TRANSACTION_TYPES';

const state = {
  bulkTransactionTypes: [],
  unitOfMeasurements: ['m3', 'Tonnes', 'bbl'],
};

const mutations = {
  [SET_BULK_TRANSACTION_TYPES](state, types) {
    state.bulkTransactionTypes = types;
  },
  [CLEAR_BULK_TRANSACTION_TYPES](state) {
    state.bulkTransactionTypes = [];
  },
};

const actions = ({
  loadBulkTransactionTypes({ commit }) {
    return BulkTransactionsService.getBulkTransactionTypes()
      .then((x) => x.data)
      .then((types) => {
        commit(SET_BULK_TRANSACTION_TYPES, types);
      })
      .catch(ErrorHandlerHelpers.handleServiceError);
  },
  createBulkTransaction({ rootState, rootGetters, dispatch }, bulkTransaction) {
    const online = rootState.userStore.isClientConnectedToServer;
    const voyageReportId = rootGetters['voyageReportsStore/getCurrentVoyageReportId'];

    if (online) {

      // Directly call the api
      return BulkTransactionsService.createBulkTransaction(bulkTransaction)
        // Get the returned model item
        .then((x) => x.data.createdTransaction)
        .then((createdTransaction) =>
          // Reload vessel activities
          dispatch('voyageReportsStore/loadVoyageVesselActivities', voyageReportId, { root: true })
/*            .then(() => dispatch('tankStatusStore/reload', createdTransaction.tank.id, {}))*/
            .then(() => dispatch('tanksStore/loadTankStatuses', createdTransaction.tank.siteId, {root: true}))
            .then(() => dispatch('voyageReportsStore/loadVoyageValidationReport', voyageReportId, { root: true }))
            .then(() => createdTransaction))
        .catch((err) => ErrorHandlerHelpers.handleServiceError(err));

    }

    if (!online) {
      ErrorHandlerHelpers.handleServiceError("Offline not supported yet.");
      return;
    }
      

    /*
      Store in IndexedDb if not online
       -> If assigned vesselActivity is unsyned (has vesselActivityIdc property) - then
       add to the unsynced vesselActivity bulkTransactions collection
       -> If assigned vesselActivity is synced (has vesselActivityId) - then add to
       IndexedDb bulkTransactions store
    */
    const { vesselActivityIdc } = bulkTransaction;
    if (vesselActivityIdc) {
      // Get and update indexedDb stored vesselActivity
      return Idb.getVesselActivityByIdc(bulkTransaction.vesselActivityIdc)
        .then((vesselActivity) => {
          const bulkTransactionToCreate = { ...bulkTransaction };

          const transactionIdc = new Date().getTime();
          bulkTransactionToCreate.idc = transactionIdc;

          vesselActivity.bulkTransactions.push(bulkTransactionToCreate);
          return Idb.updateVesselActivity(vesselActivity)
            .then((updatedIdc) => Idb.getBulkTransactionFromActivityStore(updatedIdc, transactionIdc))
            .then((createdTransaction) => dispatch('reloadSyncedAndUnsyncedActivities')
              .then(() => createdTransaction));
        });
    }

    // Save bulkTransaction in IndexedDb collection
    return Idb.saveBulkTransaction(bulkTransaction)
      .then((createdIdc) => Idb.getBulkTransactionByIdc(createdIdc))
      .then((createdTransaction) => {
        const { id, idc } = rootState.voyageReportsStore.voyageReportDetailsData;
        if (id) {
          return dispatch('voyageReportsStore/loadVoyageVesselActivities', id, { root: true })
            .then(() => dispatch('dataSyncStore/loadVesselActivitiesToBeSynced', id, { root: true }))
            .then(() => dispatch('dataSyncStore/loadAllBulkTransactionsToBeSynced', null, { root: true }))
            .then(() => createdTransaction);
        }
        return dispatch('dataSyncStore/loadVesselActivitiesToBeSynced', idc, { root: true })
          .then(() => createdTransaction);
      });
  },
  updateBulkTransaction({ rootState, rootGetters, dispatch }, bulkTransaction) {

    if (!bulkTransaction.previousVersionId) {
      console.log("Updated Attempt", bulkTransaction);
      console.trace();
    }

    const voyageReportId = rootGetters['voyageReportsStore/getCurrentVoyageReportId'];
    return BulkTransactionsService.createBulkTransaction(bulkTransaction)
      // Get the returned model item
      .then((x) => x.data.createdTransaction)
      .then((createdTransaction) =>
        // Reload vessel activities
        dispatch('voyageReportsStore/loadVoyageVesselActivities', voyageReportId, { root: true })
          /*            .then(() => dispatch('tankStatusStore/reload', createdTransaction.tank.id, {}))*/
          .then(() => dispatch('tanksStore/loadTankStatuses', createdTransaction.tank.siteId, { root: true }))
          .then(() => dispatch('voyageReportsStore/loadVoyageValidationReport', voyageReportId, { root: true }))
          .then(() => createdTransaction))
      .catch((err) => ErrorHandlerHelpers.handleServiceError(err));

    //return BulkTransactionsService.updateBulkTransaction(bulkTransactionUpdate)
    //  .then((x) => dispatch('voyageReportsStore/loadVoyageVesselActivities', rootState.voyageReportsStore.voyageReportDetailsData.id, { root: true }))
    //  .catch((err) => ErrorHandlerHelpers.handleServiceError(err));
  },
  deleteBulkTransaction({ dispatch, rootState, rootGetters }, transaction) {

    const { id, idc } = transaction;
    const online = rootState.userStore.isClientConnectedToServer;
    if (online && id && !idc) {
      const activeSiteId = rootState.userStore.activeSite
        ? rootState.userStore.activeSite.id
        : rootState.userStore.user.activeSite.id;
      const voyageReportId = rootGetters['voyageReportsStore/getCurrentVoyageReportId'];

      return BulkTransactionsService.deleteBulkTransaction(id)
        .then(() => dispatch('voyageReportsStore/loadVoyageVesselActivities', voyageReportId, { root: true }))
        .then(() => dispatch('tanksStore/loadTankStatuses', activeSiteId, { root: true }))
        .then(() => dispatch('voyageReportsStore/loadVoyageValidationReport', voyageReportId, { root: true }))
        .catch((err) => ErrorHandlerHelpers.handleServiceError(err));
    }

    // Offline Delete
    const offlineTransaction = rootState.dataSyncStore.allBulkTransactionsToBeSynced
      .find((x) => x.idc.toString() === idc.toString());

    if (offlineTransaction) {
      return Idb.deleteBulkTransaction(offlineTransaction.idc)
        .then(() => dispatch('reloadSyncedAndUnsyncedActivities'));
    }

    // If transaction is from unsynced activity - get updated activity and remove
    // bulk transaction from vesselActivity's bulk transaction array
    if (transaction.vesselActivityIdc) {
      // get unsynced vesselActivity for bulk transaction
      const unsyncedActivities = rootState.dataSyncStore.vesselActivitiesToBeSynced;
      const bulkTransactionActivity = unsyncedActivities
        .find((x) => x.idc === transaction.vesselActivityIdc);

      // filter out transaction from activity's bulkTransaction array
      bulkTransactionActivity.bulkTransactions = bulkTransactionActivity.bulkTransactions
        .filter((x) => x.bulk !== transaction.bulk
          && x.transactionType !== transaction.transactionType
          && x.quantity !== transaction.quantity
          && x.completedDateTimeLt !== transaction.completedDateTimeLt);

      // update the unsynced vesselActivity
      return Idb.updateVesselActivity(bulkTransactionActivity)
        .then(() => dispatch('reloadSyncedAndUnsyncedActivities'));
    }
    return false;
  },
  reloadSyncedAndUnsyncedActivities({ dispatch, rootState }) {
    const { id, idc } = rootState.voyageReportsStore.voyageReportDetailsData;
    if (id) {
      return dispatch('voyageReportsStore/loadVoyageVesselActivities', id, { root: true })
        .then(() => dispatch('dataSyncStore/loadVesselActivitiesToBeSynced', id, { root: true }));
    }
    return dispatch('dataSyncStore/loadVesselActivitiesToBeSynced', idc, { root: true });
  },

  // Delivery Note
  getBulkDeliveryNotePdf({ commit }, bulkTransactionId) {
    return BulkTransactionsService.getBulkDeliveryNotePdf(bulkTransactionId);
  },
  uploadBulkDeliveryNotePdf({ rootState, dispatch }, payload) {
    const { file } = payload;
    const { bulkTransactionId } = payload;
    return BulkTransactionsService.uploadBulkDeliveryNote(file, bulkTransactionId)
      .then((createdTransaction) => dispatch('voyageReportsStore/loadVoyageVesselActivities', rootState.voyageReportsStore.voyageReportDetailsData.id, { root: true })
        .then(() => createdTransaction))
      .catch(ErrorHandlerHelpers.handleServiceError);
  },
  removeBulkDeliveryNote({ rootState, dispatch }, transactionId) {
    return BulkTransactionsService.removeBulkDeliveryNote(transactionId)
      .then((createdTransaction) => dispatch('voyageReportsStore/loadVoyageVesselActivities', rootState.voyageReportsStore.voyageReportDetailsData.id, { root: true })
        .then(() => createdTransaction))
      .catch(ErrorHandlerHelpers.handleServiceError);
  },
});

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
